import SettingsDocumentsCard from './SettingsDocumentsCard';

export default SettingsDocumentsCard;
